export const ROUTE_PREFIXES = {
  practitioner: '/p',
  institution: '/i',
  admin: '/a',
} as const;
